import {
  createInitialDraft,
  createInitialOrganisationMapping,
  DEFAULT_GENERAL_PERMISSIONS,
  DEFAULT_OBJECT_PERMISSIONS,
} from './constants';

function clonePermissions(items) {
  return items.map((item) => ({ ...item }));
}

export function applyClearedDraftSlice(draft, stepKey) {
  const initial = createInitialDraft();

  switch (stepKey) {
    case 'organisation':
      return {
        ...draft,
        organisation: { ...initial.organisation },
      };
    case 'account':
      return {
        ...draft,
        account: { ...initial.account },
      };
    case 'organisation_mapping':
      return {
        ...draft,
        organisation_mapping: createInitialOrganisationMapping(),
      };
    case 'profile_users':
      return {
        ...draft,
        profile_users: { ...initial.profile_users },
        objectPermissions: clonePermissions(DEFAULT_OBJECT_PERMISSIONS),
        generalPermissions: clonePermissions(DEFAULT_GENERAL_PERMISSIONS),
        users: [],
      };
    case 'whatsapp':
      return {
        ...draft,
        whatsapp: { ...initial.whatsapp },
      };
    case 'campaign':
      return {
        ...draft,
        campaign_setup: {
          primary_goal: '',
          campaigns: [],
        },
      };
    case 'form': {
      const campaigns = (draft.campaign_setup?.campaigns || []).map((campaign) => ({
        ...campaign,
        form_fields: [],
      }));
      return {
        ...draft,
        campaign_setup: {
          ...draft.campaign_setup,
          campaigns,
        },
      };
    }
    default:
      return draft;
  }
}
